// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var CaseExternalIdType;
(function (CaseExternalIdType) {
    CaseExternalIdType[CaseExternalIdType["ARXCID"] = 1] = "ARXCID";
    CaseExternalIdType[CaseExternalIdType["NPID"] = 2] = "NPID";
    CaseExternalIdType[CaseExternalIdType["TRANID"] = 3] = "TRANID";
    CaseExternalIdType[CaseExternalIdType["MemberNumber"] = 4] = "MemberNumber";
    CaseExternalIdType[CaseExternalIdType["Mig"] = 5] = "Mig";
    CaseExternalIdType[CaseExternalIdType["MedMemberID"] = 6] = "MedMemberID";
    CaseExternalIdType[CaseExternalIdType["PharMemberID"] = 7] = "PharMemberID";
    CaseExternalIdType[CaseExternalIdType["CaseMaskID"] = 8] = "CaseMaskID";
    CaseExternalIdType[CaseExternalIdType["TCClaimID"] = 9] = "TCClaimID";
    CaseExternalIdType[CaseExternalIdType["DispositionCode"] = 10] = "DispositionCode";
    CaseExternalIdType[CaseExternalIdType["ARXRxId"] = 11] = "ARXRxId";
    CaseExternalIdType[CaseExternalIdType["StgVirmedicaDFID"] = 12] = "StgVirmedicaDFID";
    CaseExternalIdType[CaseExternalIdType["TCEobID"] = 13] = "TCEobID";
    CaseExternalIdType[CaseExternalIdType["ThirdPartyId"] = 14] = "ThirdPartyId";
    CaseExternalIdType[CaseExternalIdType["CarePathId"] = 15] = "CarePathId";
    CaseExternalIdType[CaseExternalIdType["VRMResponseId"] = 16] = "VRMResponseId";
    CaseExternalIdType[CaseExternalIdType["VRMTransactionId"] = 17] = "VRMTransactionId";
    CaseExternalIdType[CaseExternalIdType["VRMBVId"] = 18] = "VRMBVId";
    CaseExternalIdType[CaseExternalIdType["VRMPatientId"] = 19] = "VRMPatientId";
    CaseExternalIdType[CaseExternalIdType["SiteAccountId"] = 20] = "SiteAccountId";
    CaseExternalIdType[CaseExternalIdType["OtbnStgVirmedicaDFID"] = 21] = "OtbnStgVirmedicaDFID";
    CaseExternalIdType[CaseExternalIdType["ThirdPartyCaseId"] = 22] = "ThirdPartyCaseId";
    CaseExternalIdType[CaseExternalIdType["CaseMckId"] = 23] = "CaseMckId";
    CaseExternalIdType[CaseExternalIdType["ERxID"] = 24] = "ERxID";
    CaseExternalIdType[CaseExternalIdType["RemsId"] = 25] = "RemsId";
    CaseExternalIdType[CaseExternalIdType["MangoActivationId"] = 26] = "MangoActivationId";
    CaseExternalIdType[CaseExternalIdType["EnrollFeedId"] = 27] = "EnrollFeedId";
    CaseExternalIdType[CaseExternalIdType["SunovionID"] = 28] = "SunovionID";
    CaseExternalIdType[CaseExternalIdType["PharmaCordPatientId"] = 29] = "PharmaCordPatientId";
    CaseExternalIdType[CaseExternalIdType["IBondId"] = 30] = "IBondId";
    CaseExternalIdType[CaseExternalIdType["IBondEnrollmentId"] = 31] = "IBondEnrollmentId";
})(CaseExternalIdType || (CaseExternalIdType = {}));
//# sourceMappingURL=caseExternalIdType.js.map